var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"map",attrs:{"id":"map"}}),_c('NodeDetailsModal',{ref:"NodeDetailsModalRef",on:{"ok":_vm.callback}}),_c('PipelineDetailsModal',{ref:"PipelineDetailsModalRef",on:{"ok":_vm.callback}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }